/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_OngoingInputs */



/**
* | output |
* | --- |
* | "ongoing" |
*
* @param {League_OngoingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_ongoing = /** @type {((inputs?: League_OngoingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_OngoingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("en cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("en curso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("in corso")
	return /** @type {LocalizedString} */ ("ongoing")
});